import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    width: 100%;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
